var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaster01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 27,
    viewBox: "0 0 51 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0362549,
    y: 0.304688,
    width: 50,
    height: 26,
    rx: 4,
    fill: "#F7F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8427 22.3047C35.9202 22.3047 40.0363 18.2753 40.0363 13.3047C40.0363 8.33413 35.9202 4.30469 30.8427 4.30469C25.7653 4.30469 21.6492 8.33413 21.6492 13.3047C21.6492 18.2753 25.7653 22.3047 30.8427 22.3047Z",
    fill: "#F79E1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2298 22.3047C24.3073 22.3047 28.4234 18.2753 28.4234 13.3047C28.4234 8.33413 24.3073 4.30469 19.2298 4.30469C14.1523 4.30469 10.0363 8.33413 10.0363 13.3047C10.0363 18.2753 14.1523 22.3047 19.2298 22.3047Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0361 6.32666C22.9691 7.97699 21.6492 10.4899 21.6492 13.3047C21.6492 16.1194 22.9691 18.6324 25.0361 20.2827C27.1031 18.6324 28.423 16.1194 28.423 13.3047C28.423 10.4899 27.1031 7.97699 25.0361 6.32666Z",
    fill: "#FF5F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaster01);
export default __webpack_public_path__ + "static/media/master-01.72b8f3869636c820b9b140b271c0f0b2.svg";
export { ForwardRef as ReactComponent };